<label for="fileDropRef" class="upload-label">{{label | translate}}</label>
<div class="container" appDnd (fileDropped)="onFileDropped($event)">
  <input type="file" id="fileDropRef" #fileLoaderInputRef (change)="fileBrowseHandler($event)" [disabled]="readOnly"/>
  <i class="fas fa-upload"></i>
  <div class="container-upload">{{'Drop file here, or click to select file to upload' | translate}}</div>
</div>
